import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get previous prices for a product
export const getProductPreviousPrices = async (productId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-product-previous-prices`, {
      Product_Id: productId
    }, {
      headers: getAuthHeader()
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching product previous prices:', error);
    throw error;
  }
};
